/** @module Sourcing/NewFromSupplierItem */
define([
	"dojo/_base/declare",
	"csi/table/NewFrom",
	"csi/xml"
], function(declare,NewFrom,xml) {

	return declare(NewFrom, {

		/**
		 * @override
		 * Override onCreatePopup when creating a new supplier quote from an existing one.
		 * 
		 * This is added in order to give SupplierItemForm.js the correct product and also
		 * to clear existing colors and sizes if the product source differs from the target.
		 */
		onCreatePopup: function(view) {
			// since there are multiple cases of calls to this function
			if (view.defView.getType() == "Form") {
				var product = this.m_cache.getNode(this.getParent().AvailabilityProduct);
				view.setProduct(product);
				var supplierItem = view.getViewNode();
				var productParent = this.m_cache.getNode(supplierItem.__Parent__);
				if (product.$URL != productParent.AvailabilityProduct) {
					this.m_formData.setFieldInitialValue("ProductSizes", []);
					this.m_formData.setFieldInitialValue("Colors", []);
				}

			} else {
				view.relRoot.m_depPaths = view.relRoot.m_depPaths || [];
				view.relRoot.m_depPaths.push(xml.path(xml.ATTR_PARENT));
			}
		},

		/**
		 * @override
		 * Remove SRLineItem from Supplier Item
		 */
		toWriterFields: function(urlNode, fd, filter) {
			// swallow product type
			fd = fd || this.m_formData; // in case form data isn't loaded yet

			var styleType = "StyleType";
			var materialType = "MaterialType";
			if (fd.getField(styleType)) {
				fd.getFieldValue(styleType, true);
			}

			if (fd.getField(materialType)) {
				fd.getFieldValue(materialType, true);
			}

		}
	});
});